/* ==========================================================================
   social-proof.js — Slider de vídeos + controles inline + Modal fullscreen
   ========================================================================== */

(function () {
  'use strict';

  /* -------------------------------------------------------------------------
     SLIDER DE VÍDEOS
  ------------------------------------------------------------------------- */

  function initVideoSliders() {
    document.querySelectorAll('[data-sp-slider]').forEach(function (slider) {
      if (slider.dataset.spSliderInit) return;
      slider.dataset.spSliderInit = '1';

      var track       = slider.querySelector('.sp-videos__track');
      var slides      = Array.from(slider.querySelectorAll('.sp-videos__slide'));
      var prevBtn     = slider.querySelector('[data-sp-prev]');
      var nextBtn     = slider.querySelector('[data-sp-next]');
      var dotsWrapper = slider.querySelector('.sp-videos__dots');

      if (!track || slides.length === 0) return;

      var currentIndex = 0;

      function getSlidesPerView() {
        var sliderW = slider.querySelector('.sp-videos__track-wrapper').offsetWidth;
        var slideW  = slides[0].offsetWidth + 16; /* gap = 16px */
        return Math.max(1, Math.round(sliderW / slideW));
      }

      function maxIndex() {
        return Math.max(0, slides.length - getSlidesPerView());
      }

      function buildDots() {
        if (!dotsWrapper) return;
        dotsWrapper.innerHTML = '';
        var total = maxIndex() + 1;
        for (var i = 0; i < total; i++) {
          var btn = document.createElement('button');
          btn.className = 'sp-videos__dot' + (i === currentIndex ? ' is-active' : '');
          btn.setAttribute('aria-label', 'Ir para slide ' + (i + 1));
          btn.dataset.spDot = i;
          dotsWrapper.appendChild(btn);
        }
      }

      function updateDots() {
        if (!dotsWrapper) return;
        dotsWrapper.querySelectorAll('.sp-videos__dot').forEach(function (d, i) {
          d.classList.toggle('is-active', i === currentIndex);
        });
      }

      function goTo(index) {
        currentIndex = Math.min(Math.max(0, index), maxIndex());
        var slideW = slides[0].offsetWidth + 16;
        track.style.transform = 'translateX(-' + (currentIndex * slideW) + 'px)';
        updateDots();
        if (prevBtn) prevBtn.disabled = currentIndex === 0;
        if (nextBtn) nextBtn.disabled = currentIndex >= maxIndex();
      }

      buildDots();
      goTo(0);

      if (prevBtn) prevBtn.addEventListener('click', function () { goTo(currentIndex - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { goTo(currentIndex + 1); });

      if (dotsWrapper) {
        dotsWrapper.addEventListener('click', function (e) {
          var dot = e.target.closest('[data-sp-dot]');
          if (dot) goTo(Number(dot.dataset.spDot));
        });
      }

      /* Touch swipe (mobile) */
      var wrapper = slider.querySelector('.sp-videos__track-wrapper');
      if (wrapper) {
        var touchStartX = 0;
        var touchStartY = 0;

        wrapper.addEventListener('touchstart', function (e) {
          touchStartX = e.touches[0].clientX;
          touchStartY = e.touches[0].clientY;
        }, { passive: true });

        wrapper.addEventListener('touchend', function (e) {
          var deltaX = e.changedTouches[0].clientX - touchStartX;
          var deltaY = e.changedTouches[0].clientY - touchStartY;
          if (Math.abs(deltaX) < Math.abs(deltaY)) return;
          if (Math.abs(deltaX) < 40) return;
          goTo(deltaX < 0 ? currentIndex + 1 : currentIndex - 1);
        }, { passive: true });
      }

      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          buildDots();
          goTo(Math.min(currentIndex, maxIndex()));
        }, 200);
      });
    });
  }

  /* -------------------------------------------------------------------------
     CONTROLES INLINE POR SLIDE (play/pause + mute/unmute)
  ------------------------------------------------------------------------- */

  function initSlideControls() {
    document.querySelectorAll('.sp-videos__slide').forEach(function (slide) {
      if (slide.dataset.spControlsInit) return;
      slide.dataset.spControlsInit = '1';

      var video   = slide.querySelector('.sp-videos__slide-video');
      var playBtn = slide.querySelector('[data-sp-play]');
      var muteBtn = slide.querySelector('[data-sp-mute]');

      if (!video) return;

      /* Sincroniza o ícone de play/pause com o estado real do vídeo */
      function syncPlayIcon() {
        var playing = !video.paused;
        if (playBtn) {
          playBtn.classList.toggle('is-playing', playing);
          playBtn.setAttribute('aria-label', playing ? 'Pausar' : 'Reproduzir');
        }
      }

      /* Sincroniza ícone de mute */
      function syncMuteIcon() {
        if (muteBtn) {
          muteBtn.classList.toggle('is-muted', video.muted);
          muteBtn.setAttribute('aria-label', video.muted ? 'Desmutar' : 'Mutar');
        }
      }

      video.addEventListener('play',  syncPlayIcon);
      video.addEventListener('pause', syncPlayIcon);

      /* Autoplay pode falhar — se falhar, atualiza ícone */
      video.play().then(syncPlayIcon).catch(function () {
        syncPlayIcon();
      });

      if (playBtn) {
        playBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          if (video.paused) {
            video.play().catch(function () {});
          } else {
            video.pause();
          }
        });
      }

      if (muteBtn) {
        muteBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          video.muted = !video.muted;
          syncMuteIcon();
        });
      }
    });
  }

  /* -------------------------------------------------------------------------
     MODAL FULLSCREEN
     Abre ao clicar no botão [data-sp-fullscreen].
     Pausa o vídeo do slide enquanto o modal está aberto.
  ------------------------------------------------------------------------- */

  function initVideoModal() {
    var modal    = document.getElementById('sp-video-modal');
    var videoEl  = modal && modal.querySelector('.sp-video-modal__video');
    var closeBtn = modal && modal.querySelector('.sp-video-modal__close');

    if (!modal || !videoEl) return;

    var activeSlideVideo = null;

    function openModal(src, slideVideo) {
      activeSlideVideo = slideVideo || null;
      /* Pausa o preview do slide enquanto o modal toca */
      if (activeSlideVideo) activeSlideVideo.pause();

      videoEl.src = src;
      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      videoEl.play().catch(function () {});
    }

    function closeModal() {
      videoEl.pause();
      videoEl.src = '';
      modal.classList.remove('is-open');
      document.body.style.overflow = '';

      /* Retoma o vídeo do slide */
      if (activeSlideVideo) {
        activeSlideVideo.play().catch(function () {});
        activeSlideVideo = null;
      }
    }

    modal.addEventListener('click', function (e) {
      if (e.target === modal) closeModal();
    });

    if (closeBtn) closeBtn.addEventListener('click', closeModal);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
    });

    /* Delegação: apenas botão [data-sp-fullscreen] abre o modal */
    document.addEventListener('click', function (e) {
      var fsBtn = e.target.closest('[data-sp-fullscreen]');
      if (!fsBtn) return;
      e.stopPropagation();
      var slide      = fsBtn.closest('.sp-videos__slide');
      var src        = slide && slide.dataset.spVideoSrc;
      var slideVideo = slide && slide.querySelector('.sp-videos__slide-video');
      if (src) openModal(src, slideVideo);
    });
  }

  /* -------------------------------------------------------------------------
     INIT
  ------------------------------------------------------------------------- */

  function init() {
    initVideoSliders();
    initSlideControls();
    initVideoModal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
